module.exports = __webpack_public_path__ + "img/v3-tick-light.efff55b1.svg";